const { sessionGet, sessionSet, apiResult } = require("../Utils/Common")

const loadProducts = (apis,callback,setError)=>{
    let datas = sessionGet('products')
    if(datas) {
        callback && callback(datas)
    }else {
        apis.loadProducts(0,1000,0).then(ret=>{
            apiResult(ret,(areas)=>{
                sessionSet('products',areas.data)
                callback(areas.data)
            },setError)
        })
    }
}

const settingDataLoader = (item,status,apis,callback,setError,fresh) => {
    let datas = sessionGet('session-'+item)
    if(datas && !fresh) {
        callback && callback(datas)
    }else {
        apis.settingGet(item,0,status).then(ret=>{
            apiResult(ret,(datas)=>{
                sessionSet('session-'+item,datas)
                callback && callback(datas)
            },setError)
        })
    }
}
const loadCourseCategories = (apis,callback,setError,simple=1,fresh=false)=>{
    let datas = sessionGet('coursecategories')
    if(datas && !fresh) {
        callback && callback(datas)
    }else {
        apis.courseCategoryGet(0,simple).then(ret=>{
            apiResult(ret,(datas)=>{
                sessionSet('coursecategories',datas)
                callback && callback(datas)
            },setError)
        })
    }
}
const loadCategoryCourses = (apis,callback,setError,fresh=false)=>{
    let datas = sessionGet('coursecategories')
    if(datas && !fresh) {
        callback && callback(datas)
    }else {
        apis.loadCategoryCourses().then(ret=>{
            apiResult(ret,(datas)=>{
                sessionSet('categorycourses',datas)
                callback && callback(datas)
            },setError)
        })
    }
}
const loadCoursePackages = (category_id,status,apis,callback,setError,fresh=false)=>{
    let datas = sessionGet('course_packages')
    if(datas && !fresh) {
        callback && callback(datas)
    }else {
        apis.coursepackageGet(category_id,status).then(ret=>{
            apiResult(ret,(datas)=>{
                sessionSet('course_packages',datas)
                callback && callback(datas)
            },setError)
        })
    }
}
const getItemsFromObjects = (objs,id)=>{
    if(objs && objs.length>0) {
        for(let i=0;i<objs.length;i++) {
            if(objs[i].id == id) {
                return objs[i]
            }
        }
    }
    return undefined
}
export {
    loadProducts,
    loadCourseCategories,
    loadCategoryCourses,
    loadCoursePackages,
    settingDataLoader,
    getItemsFromObjects
}